import script from "./Academic.vue?vue&type=script&setup=true&lang=js"
export * from "./Academic.vue?vue&type=script&setup=true&lang=js"

import "./Academic.vue?vue&type=style&index=0&id=fde77472&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fde77472"]])

export default __exports__